import React from 'react';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { useRestaurant, useExperiences } from 'query/hooks';

import { NextIcon } from 'icons';
import messages from 'messages';

function Choose({ ...props }) {
    const { formatMessage } = props.intl;

    const apps = useRestaurant()?.data?.apps || { experiences: { show: false } };
    const domain = useRestaurant()?.data?.domain || '';
    const experiences = useExperiences()?.data || [];

    const showExperiences = apps.experiences.show && experiences.length > 0;

    return (
        <div className="page-wrapper page-choose">
            <h2 className="title">{formatMessage(messages.chooseTitle)}</h2>
            <h3 className="subtitle">{formatMessage(messages.chooseSubtitle)}</h3>

            <div className="options">
                <div className="option">
                    <Link to={`/${domain}/amount`} data-test="choose-amount">
                        <div className="header">
                            <h3>{formatMessage(messages.chooseTypeAmount)}</h3>
                            <NextIcon size={16} className="icon" />
                        </div>

                        <p>{formatMessage(messages.chooseTypeAmountDescription)}</p>
                    </Link>
                </div>

                {showExperiences ? (
                    <div className="option">
                        <Link to={`/${domain}/experience`} data-test="choose-experience">
                            <div className="header">
                                <h3>{formatMessage(messages.chooseTypeExperience)}</h3>
                                <NextIcon size={16} className="icon" />
                            </div>

                            <p>{formatMessage(messages.chooseTypeExperienceDescription)}</p>
                        </Link>
                    </div>
                ) : (
                    ''
                )}
            </div>
        </div>
    );
}

export default injectIntl(React.memo(Choose));
